module.exports = __webpack_public_path__ + "img/no-image.e1ea0ff5.png";